import React, { useMemo, useState } from "react";
import RfmModalBase from "./RfmModalBase";
//API 
import { BranchOfficeEnvironmentsFetchAPI } from "../../../../api/BranchOfficeEnvironments";


const DEFAULT_COLORS = [
  "#3b82f6", "#10b981", "#f59e0b", "#ef4444",
  "#8b5cf6", "#ec4899", "#06b6d4", "#84cc16",
];

export default function RfmCreateZoneModal({ open, onClose, onCreate, branchoffice, token }) {
  const [name, setName] = useState("");
  const [color, setColor] = useState(DEFAULT_COLORS[0]);
  const [cols, setCols] = useState(50);
  const [rows, setRows] = useState(100);

  const canSubmit = useMemo(() => name.trim().length > 0, [name]);

  const submit = async () => {
    if (!canSubmit) return;
    let payload = {
      name: name.trim(),
      color,
      grid_cols: Number(cols) || 50,
      grid_rows: Number(rows) || 10,
      branchoffice_id: branchoffice?.id,
    }

    try {
      let response = await BranchOfficeEnvironmentsFetchAPI.createBranchofficeEnvironment(payload, branchoffice?.id, token);
      console.log("Environment created:", response.data.data);
      onCreate?.(response.data.data);
      setName("");
      setColor(DEFAULT_COLORS[0]);
      setCols(50);
      setRows(100);
      onClose?.();
    } catch (e) {

    }


  };

  return (
    <RfmModalBase
      open={open}
      title="Nueva Zona"
      onClose={onClose}
      footer={
        <div className="ord-footer">
          <button className="ord-btn ord-btn-secondary" type="button" onClick={onClose}>
            Cancelar
          </button>
          <button className="ord-btn ord-btn-primary" type="button" onClick={submit} disabled={!canSubmit}>
            <i className="bi bi-plus-lg" /> Crear
          </button>
        </div>
      }
    >
      <div className="ord-form-group">
        <label className="ord-form-label">Nombre</label>
        <input className="ord-form-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Ej: Terraza" />
      </div>

      <div className="ord-form-group">
        <label className="ord-form-label">Color</label>
        <div className="ord-color-picker">
          {DEFAULT_COLORS.map((c) => (
            <div
              key={c}
              className={`ord-color-option ${color === c ? "active" : ""}`}
              data-color={c}
              style={{ background: c }}
              onClick={() => setColor(c)}
            />
          ))}
        </div>
      </div>

      <div className="ord-form-row">
        <div className="ord-form-group">
          <label className="ord-form-label">Columnas</label>
          <input className="ord-form-input" type="number" min={10} max={100} value={cols} onChange={(e) => setCols(e.target.value)} />
        </div>
        <div className="ord-form-group">
          <label className="ord-form-label">Filas</label>
          <input className="ord-form-input" type="number" min={20} max={200} value={rows} onChange={(e) => setRows(e.target.value)} />
        </div>
      </div>
    </RfmModalBase>
  );
}
